import React from 'react';
import ProductHubDashboardV2 from '../ProductHubDashboard/ProductHubDashboardV2';

const FastLaneHubView = () => {
  return <ProductHubDashboardV2 productCode="flane" productLabel="FastLane" />;
};

export default FastLaneHubView;
